/**
 * Places 照片一律走 /trip/place/{placeId}/photo 這個後端端點，由後端用不會過期的
 * placeId 現場換一組保證有效的 photoReference，再轉址到 /photos/ 反代快取（見
 * nginx.railway.conf）。photoReference 本身存在資料庫裡會過期，不能直接拿來組網址；
 * 這個轉址沿用既有的兩層快取（後端 60 天 Place Detail 快取、nginx 30 天圖片快取），
 * 不會增加額外的 Google API 用量。
 */
export function getPlacePhotoUrl(
  placeId: string | null | undefined,
  maxWidthPx = 600
): string | null {
  if (!placeId) return null;
  return `/trip/place/${placeId}/photo?maxWidthPx=${maxWidthPx}`;
}
